import React from "react";

export default function StatCard({ icon, label, value, change, color, bg, onClick }) {
  return (
    <div className="stat-card" onClick={onClick} style={{ cursor: onClick ? "pointer" : "default" }}>
      <div className="stat-icon" style={{ background: bg || "#e8eef8", color: color || "var(--blue-700)" }}>
        {icon}
      </div>
      <div>
        <div className="stat-value">{value}</div>
        <div className="stat-label">{label}</div>
        {change && (
          <div className={`stat-change ${change.type}`}>
            {change.type === "up" ? "↑" : "↓"} {change.text}
          </div>
        )}
      </div>
    </div>
  );
}
